/**
 * Warenkorb-Lade nach dem Hinzufuegen zuverlaessig oeffnen.
 *
 * Horizon aktualisiert die Lade nach einem Hinzufuegen ueber ein punktuelles
 * Ersetzen markierter Bereiche und oeffnet sie danach. In diesem Shop kommt der
 * neue Inhalt dabei nicht an: Die Lade bleibt leer — und weil Horizon das
 * Oeffnen bei leerer Lade ausdruecklich unterdrueckt, passiert sichtbar nichts.
 * Der Artikel landet trotzdem im Warenkorb.
 *
 * Nachgemessen am Live-Shop: Der Server liefert den fertigen Abschnitt korrekt
 * inklusive Artikel, und das Oeffnen selbst funktioniert. Nur der Einbau im
 * Browser scheitert.
 *
 * Ausloeser ist bewusst der Klick auf den Kaufbutton und nicht Horizons
 * internes Ereignis: Dessen Name steht nur im komprimierten Shopify-Code und
 * kann sich jederzeit aendern. Ob wirklich etwas hinzugefuegt wurde, wird
 * danach am Warenkorb selbst geprueft — nicht vermutet.
 *
 * Konfigurierte Huellen laufen hier nicht durch: Die Konfigurator-App markiert
 * den Kaufbutton mit data-rxk-bound und oeffnet die Lade selbst.
 */
(function () {
  'use strict';

  var SECTION = 'cart-drawer-section';
  var BUTTONS = 'button[name="add"], .add-to-cart-button, button[type="submit"].button';

  function productForm(button) {
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return null;
    if (button.closest('[data-rxk-widerruf]')) return null;
    var form = button.form || button.closest('form');
    if (!form) return null;
    var action;
    try { action = new URL(button.getAttribute('formaction') || form.action, location.href); }
    catch (error) { return null; }
    if (action.origin !== location.origin || !/\/cart\/add(?:\.js)?\/?$/.test(action.pathname)) return null;
    var variant = form.querySelector('[name="id"]');
    return variant && /^\d+$/.test(variant.value) ? form : null;
  }

  console.info('[RXK] Lade-Rueckfall aktiv');

  /**
   * Schleier hinter der Lade.
   *
   * Frueher lag ein filter: blur() auf der ganzen Seite. Der Browser musste sie
   * dafuer komplett neu zeichnen — samt allem, was gerade gar nicht sichtbar
   * ist. Ein eigenes Element mit backdrop-filter rechnet nur, was tatsaechlich
   * dahinter liegt, also den sichtbaren Ausschnitt.
   *
   * Es haengt an body, ist nie anklickbar und blendet ueber die Deckkraft ein —
   * dadurch faehrt der Schleier mit der Lade auf statt schlagartig zu
   * erscheinen. Sichtbar wird es allein ueber CSS, sobald eine Lade offen ist.
   */
  function legeSchleierAn() {
    if (document.querySelector('.rxk-scrim')) return;
    var scrim = document.createElement('div');
    scrim.className = 'rxk-scrim';
    scrim.setAttribute('aria-hidden', 'true');
    document.body.appendChild(scrim);
  }

  if (document.body) legeSchleierAn();
  else document.addEventListener('DOMContentLoaded', legeSchleierAn);

  /**
   * Schleier auch hinter dem Konto-Fenster (Andreas 17.09.2026: beim Konto
   * "kommt kein blurred").
   *
   * Das Konto-Fenster ist Shopifys <shopify-account>-Komponente. Ihr Dialog
   * liegt im Shadow-DOM und setzt beim Oeffnen nur dort ein open-Attribut —
   * nach aussen zeigt die Komponente nichts, CSS kann den Zustand also nicht
   * abfragen (:has() sieht nicht in Shadow-Baeume). Deshalb beobachtet dieses
   * Skript den Dialog und spiegelt den Zustand als data-rxk-konto-offen auf
   * body; die Schleier-Regel steht in roxxlyn-aspect.css neben der der Lade.
   *
   * Der Shadow-Baum entsteht erst, wenn Shopifys Skript die Komponente
   * definiert hat, darum wird auf whenDefined gewartet und danach kurz
   * nachgefasst, bis der Dialog da ist.
   */
  function beobachteKontoFenster() {
    var host = document.querySelector('shopify-account');
    if (!host || !window.MutationObserver) return;

    var versuche = 0;
    function anbinden() {
      var dialog = host.shadowRoot && host.shadowRoot.querySelector('dialog');
      if (!dialog) {
        if (versuche++ < 40) setTimeout(anbinden, 250);
        return;
      }
      function spiegeln() {
        if (dialog.hasAttribute('open')) document.body.setAttribute('data-rxk-konto-offen', '');
        else document.body.removeAttribute('data-rxk-konto-offen');
      }
      new MutationObserver(spiegeln).observe(dialog, { attributes: true, attributeFilter: ['open'] });
      spiegeln();
    }

    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('shopify-account').then(anbinden, anbinden);
    } else {
      anbinden();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', beobachteKontoFenster);
  } else {
    beobachteKontoFenster();
  }

  /**
   * Laesst genau die gekaufte Position stehen und raeumt den Rest weg.
   *
   * Das Panel liefert alle Positionen, weil der Server nicht wissen kann,
   * welche gerade geklickt wurde. "Die letzte im Warenkorb" waere geraten und
   * falsch, sobald das Produkt schon drinlag — Shopify erhoeht dann nur dessen
   * Menge und laesst es an seiner Stelle.
   *
   * Aufpreiszeilen (data-rxk-sub) gehoeren zur Hauptzeile darueber und folgen
   * deren Schicksal.
   */
  function keepOnly(host, variantId) {
    if (!variantId) return true;

    // Erst pruefen, ob die gekaufte Position ueberhaupt schon im Warenkorb
    // steht. Sie fehlt, wenn der Abschnitt geholt wurde, bevor Shopify den
    // Kauf verbucht hatte. Wuerde dann gefiltert, bliebe eine leere Lade
    // zurueck — schlimmer als eine mit veraltetem Inhalt.
    var lines = host.querySelectorAll('.rxk-ja__line');
    var selectedLine = null;
    for (var p = 0; p < lines.length; p++) {
      if (
        !lines[p].hasAttribute('data-rxk-sub') &&
        lines[p].getAttribute('data-rxk-variant') === String(variantId)
      ) {
        selectedLine = lines[p];
        break;
      }
    }
    if (!selectedLine) return false;

    var keeping = false;
    for (var i = 0; i < lines.length; i++) {
      var el = lines[i];
      if (!el.hasAttribute('data-rxk-sub')) {
        keeping = el === selectedLine;
      }
      if (!keeping) el.remove();
    }
    var panel = host.querySelector('.rxk-ja');
    var rest = host.querySelector('.rxk-ja__rest');
    if (panel && rest) {
      var visibleQuantity = 0;
      host.querySelectorAll('.rxk-ja__line:not([data-rxk-sub])').forEach(function (line) {
        visibleQuantity += Number(line.getAttribute('data-rxk-quantity')) || 1;
      });
      rest.hidden = Number(panel.getAttribute('data-rxk-product-count')) <= visibleQuantity;
    }
    return true;
  }

  // Die Konfigurator-App laedt die Lade nach ihren eigenen Kaeufen selbst neu
  // und braucht denselben Filter — sonst stapeln sich dort alle Positionen.
  window.rxkKeepOnly = keepOnly;

  /**
   * Nie offen in eine Seite starten.
   *
   * Horizon merkt sich den offenen Zustand ueber Seitenwechsel und stellt ihn
   * beim Laden wieder her. Wer aus der Lade heraus weiterklickt, landet damit
   * auf der neuen Seite mit offener Lade und weichgezeichnetem Hintergrund —
   * und darin stehen alle Warenkorb-Positionen, weil nach dem Seitenwechsel
   * niemand gefiltert hat. Die Lade gehoert hier aber dem gerade
   * Hinzugefuegten, nicht dem Warenkorb.
   */
  function schliesseBeimStart() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer || !drawer.hasAttribute('open')) return;

    if (typeof drawer.close === 'function') drawer.close();
    else drawer.removeAttribute('open'); // Komponente noch nicht bereit
  }

  /**
   * Den Merker fuer die Warenkorb-Lade loeschen.
   *
   * Horizon legt die offenen Laden in sessionStorage ab und stellt sie beim
   * naechsten Seitenaufruf ueber ein synchrones Skript wieder her — das laeuft
   * vor dieser Datei, weshalb blosses Schliessen zu spaet kaeme. Deshalb wird
   * der Eintrag beim Verlassen der Seite entfernt: Dann gibt es beim naechsten
   * Aufruf nichts wiederherzustellen. Andere Laden (Menue, Chat) bleiben
   * unberuehrt.
   */
  function vergissLade() {
    try {
      var ids = (sessionStorage.getItem('theme-drawer-open') || '').split(',');
      var rest = ids.filter(function (id) {
        return id && id !== 'cart-drawer';
      });
      if (rest.length) sessionStorage.setItem('theme-drawer-open', rest.join(','));
      else sessionStorage.removeItem('theme-drawer-open');
    } catch (e) {
      /* privater Modus o. ae. — dann bleibt es beim Schliessen unten */
    }
  }

  vergissLade();
  window.addEventListener('pagehide', vergissLade);
  window.addEventListener('beforeunload', vergissLade);

  schliesseBeimStart();
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('theme-drawer').then(schliesseBeimStart);
  }
  document.addEventListener('DOMContentLoaded', schliesseBeimStart);

  /**
   * Die Lade leeren, sobald sie zugeht.
   *
   * Beim naechsten Kauf faehrt sie sofort auf, der frische Inhalt kommt aber
   * erst eine knappe halbe Sekunde spaeter. In dieser Zeit blitzte das zuvor
   * gekaufte Produkt auf. Beim Kaufklick zu raeumen reicht nicht: Da ist die
   * Lade schon im Begriff aufzugehen. Geleert wird deshalb, wenn niemand
   * hinsieht — direkt nach dem Schliessen.
   */
  function leereNachSchliessen() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer || !window.MutationObserver) return;

    new MutationObserver(function () {
      if (drawer.hasAttribute('open')) return;

      var host = document.querySelector('cart-drawer-component');
      if (!host) return;
      var zeilen = host.querySelectorAll('.rxk-ja__line');
      for (var i = 0; i < zeilen.length; i++) zeilen[i].remove();
    }).observe(drawer, { attributes: true, attributeFilter: ['open'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', leereNachSchliessen);
  } else {
    leereNachSchliessen();
  }

  // Shopify drosselt haeufige Abrufe mit 429. Das trifft schnelles
  // Hintereinanderklicken — einmal kurz warten und erneut versuchen genuegt.
  function holeAbschnitt(schonWiederholt) {
    var url = window.location.pathname + '?section_id=' + SECTION + '&_rxk=' + Date.now();
    return fetch(url, { cache: 'no-store' }).then(function (res) {
      if (res.status === 429 && !schonWiederholt) {
        return new Promise(function (weiter) {
          setTimeout(weiter, 1200);
        }).then(function () {
          return holeAbschnitt(true);
        });
      }
      if (!res.ok) throw new Error('Abschnitt nicht erreichbar: ' + res.status);
      return res.text();
    });
  }

  function fillAndOpen(drawer, host, variantId, versuch) {
    versuch = versuch || 1;

    return holeAbschnitt(false).then(function (html) {
      var fresh = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector('cart-drawer-component');
      if (fresh) host.innerHTML = fresh.innerHTML;

      // Steht der Kauf noch nicht im Warenkorb, war der Abschnitt zu frueh
      // geholt. Wie lange Shopify braucht, schwankt — deshalb nachfassen
      // statt eine feste Wartezeit zu raten.
      if (!keepOnly(host, variantId) && versuch < 4) {
        return new Promise(function (weiter) {
          setTimeout(weiter, 700);
        }).then(function () {
          return fillAndOpen(drawer, host, variantId, versuch + 1);
        });
      }

      // Nur oeffnen, wenn sie zu ist. open() auf einer offenen Lade holt sie
      // in Horizon nach vorn und spielt die Einfahrt erneut ab — sie wirkte
      // dadurch, als ginge sie zweimal auf.
      if (!drawer.hasAttribute('open')) {
        drawer.open();
        console.info('[RXK] Lade befuellt und geoeffnet (Versuch ' + versuch + ')');
      } else {
        console.info('[RXK] Lade war offen — Inhalt erneuert (Versuch ' + versuch + ')');
      }
    });
  }

  /**
   * Klick neben die Lade schliesst sie.
   *
   * Horizon oeffnet die Lade ab Tablet-Breite bewusst nicht-modal, damit die
   * Seite daneben bedienbar bleibt. Dadurch gibt es aber keinen Hintergrund,
   * auf den man klicken koennte — Horizons Schliess-Handler haengt am Fenster
   * selbst und wird von aussen nie erreicht. Kunden kamen nur ueber das X
   * wieder heraus. Am Handy oeffnet Horizon modal, dort greift sein eigener
   * Weg und dieser hier bleibt wirkungslos.
   */
  document.addEventListener('click', function (event) {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer || !drawer.hasAttribute('open')) return;

    var target = event.target;
    if (!target || !target.closest) return;
    if (drawer.contains(target)) return; // Klick in der Lade

    // Der Kaufklick selbst darf nicht sofort wieder schliessen — er liegt
    // ausserhalb der Lade und wuerde sonst genau das ausloesen.
    if (productForm(target.closest(BUTTONS))) return;

    if (typeof drawer.close === 'function') drawer.close();
  });

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var btn = target.closest(BUTTONS);
      var form = productForm(btn);
      if (!form) return;

      // Der Konfigurator hat diesen Button uebernommen — er oeffnet selbst.
      if (btn.dataset && btn.dataset.rxkBound) {
        console.info('[RXK] Klick gehoert dem Konfigurator — Rueckfall haelt sich raus');
        return;
      }
      if (!form.checkValidity()) return;

      var drawer = document.getElementById('cart-drawer');
      var host = document.querySelector('cart-drawer-component');
      if (!drawer || !host || typeof drawer.open !== 'function') {
        console.warn('[RXK] Lade nicht gefunden', {
          drawer: !!drawer,
          host: !!host,
          open: drawer ? typeof drawer.open : '—',
        });
        return;
      }

      // Welche Variante abgeschickt wird, steht im Formular des Buttons.
      var idInput = form.querySelector('[name="id"]');
      var variantId = idInput ? idInput.value : null;

      console.info('[RXK] Kaufklick erkannt — Variante', variantId || '(unbekannt)');

      // Alte Positionen sofort raeumen. Horizon oeffnet die Lade unmittelbar,
      // der frische Inhalt kommt erst gut 400 ms spaeter — dazwischen stand
      // sonst das zuvor betrachtete Produkt, das dann sichtbar ausgetauscht
      // wurde. Lieber kurz keine Position zeigen als die falsche.
      var alteZeilen = host.querySelectorAll('.rxk-ja__line');
      for (var a = 0; a < alteZeilen.length; a++) alteZeilen[a].remove();

      // Horizon Zeit lassen: erst den Warenkorb fuellen, dann selbst oeffnen.
      // Der Inhalt wird in jedem Fall frisch geholt. Horizon oeffnet die Lade
      // zwar, aktualisiert sie aber nicht — sie zeigt dann den Stand vom
      // Seitenaufruf, also das zuletzt betrachtete statt des gerade
      // hinzugefuegten Produkts. Zu pruefen, "ob etwas drinsteht", genuegt
      // deshalb nicht: Es steht etwas drin, nur das Falsche.
      setTimeout(function () {
        fillAndOpen(drawer, host, variantId).catch(function (err) {
          console.warn('[RXK] Lade konnte nicht befuellt werden:', err);
        });
      }, 250);
    },
    true
  );
})();
